import { render, staticRenderFns } from "./updateReason.vue?vue&type=template&id=bec1a53c&"
import script from "./updateReason.vue?vue&type=script&lang=js&"
export * from "./updateReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports